import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, ModalBody, ModalHeader, Spinner } from "reactstrap";

import { updateConfirmationModalState } from "../Actions";
import CrossSVG from "../../SVGs/Cross";
import "./styles.scss";

const ProcessConfirmation = () => {
  const shouldOpen = useSelector(
    (state) => state.modalsState?.confirmationProcess?.shouldOpen
  );

  const loading = useSelector(
    (state) => state.modalsState?.confirmationProcess?.loading
  );

  const message = useSelector(
    (state) => state.modalsState?.confirmationProcess?.message
  );

  const func = useSelector(
    (state) => state.modalsState?.confirmationProcess?.func
  );

  const dispatch = useDispatch();

  const handleConfirm = () => {
    func();
    dispatch(updateConfirmationModalState({ loading: true }));
  };

  return (
    <Modal
      size="sm"
      style={{ maxWidth: "623px" }}
      isOpen={shouldOpen}
      className="ProcessConfirmation modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <span
          role="button"
          onClick={() =>
            dispatch(
              updateConfirmationModalState({ shouldOpen: false, message: "" })
            )
          }
        >
          <CrossSVG />
        </span>
      </ModalHeader>
      <ModalBody>
        <>
          <div className="d-flex justify-content-center">
            <div className="message">
              <span>{message}</span>
            </div>
          </div>

          <div className="confirmation-btns">
            <Button
              className="btn-confirmation-process"
              size="lg"
              color="outline-primary"
              onClick={() =>
                dispatch(
                  updateConfirmationModalState({
                    shouldOpen: false,
                    message: "",
                  })
                )
              }
            >
              No
            </Button>
            <Button
              className="btn-confirmation-process"
              size="lg"
              color="primary"
              onClick={handleConfirm}
            >
              <div className="btn-loading">
                <div>Yes</div>
                <div>{loading && <Spinner size="sm" />}</div>
              </div>
            </Button>
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default ProcessConfirmation;
